import { ofetch } from 'ofetch'

export default () => {
  const { $config } = useNuxtApp()
  const controller = new AbortController()
  const signal = controller.signal
  const timeout = setTimeout(() => controller.abort(), $config.public.API_TIMEOUT)
  const token = useCookie('token', { path: '/', domain: $config.public.COOKIE_DOMAIN })

  return ofetch.create({
    baseURL: $config.public.COMPANYAPI_BASE_URL,
    signal,
    async onRequest({ options }) {
      if (token.value) {
        options.headers = new Headers(options.headers)
        options.headers.append('Authorization', `Bearer ${token.value}`)
      }
    },
    async onRequestError({ error }) {
      clearTimeout(timeout)
      throw error
    },
    async onResponse() {
      clearTimeout(timeout)
    },
    async onResponseError({ request, response }) {
      clearTimeout(timeout)
      console.error('[fetch response error]', request, response.status, response.body)
    },
  })
}
